import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'formatTime',
})
export class FormatTimePipe implements PipeTransform {
  transform(value: Date | DateTime | string, format = 'HH:mm'): string {
    if (value instanceof DateTime) {
      return value.toFormat(format);
    }
    if (typeof value === 'string') {
      const dateTime = DateTime.fromISO(value);
      if (!dateTime.isValid) {
        throw new Error('Invalid date string format');
      }
      return dateTime.toFormat(format);
    }
    if (value instanceof Date) {
      return DateTime.fromJSDate(value).toFormat(format);
    }
    throw new Error('Unsupported date format');
  }
}
